import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import AboutInvestingImg1 from "../../assets/img/about/about-investing-img-1.jpg";
// import AboutInvestingImg2 from '../../assets/img/about/about-investing-img-2.jpg';
import { useLocation } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function AboutInvesting({ id, scrollToSection, data }) {

  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to this section if the hash matches
    if (location.hash.replace("#", "") === id && scrollToSection) {
      scrollToSection();
    }
  }, [location.hash, id, scrollToSection]);


  const descriptions = data.section_description
    ? JSON.parse(data.section_description)
    : [];

  return (
    <section
      className="about-investing-sec"
      id={id}
    >
      <Container fluid className="about-investing-container">
        <Row className="banner-text-center">
          <Col md={6}>
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {data.title}
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="flex-center about-investing-row">
          <Col md={6}>
            <div
              className="about-investing-content-div"
              data-aos="fade-right"
            >
              <h3 className="common-head goldenColor">
                {data.section_title}
              </h3>
              {descriptions.map((description, index) => (
                <p className="common-para" key={index}>
                  {descriptions[index]}
                </p>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <img
              src={apiUrl.apiUrl + `/` + data.first_image}
              className="img-fluid"
              alt="Marquis Luxury Real Estate"
              data-aos="fade-down"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
export default AboutInvesting;
